import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/modules/shared.module';
import { NgxEditorModule } from 'ngx-editor';
import { LocalidadModule } from './localidad.module';
import { ConfiguracionComponent } from '../views/configuracion/configuracion/configuracion.component';
import { EmpresaComponent } from '../views/configuracion/empresa/empresa.component';
import { NavPanelConfiguracionComponent } from '../views/configuracion/nav-panel-configuracion/nav-panel-configuracion.component';
import { LogoComponent } from '../views/logo/logo.component';
import { ArchivosModule } from './archivos.module';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    LocalidadModule,
    ArchivosModule,
    NgxEditorModule
  ],
  declarations: [
    NavPanelConfiguracionComponent,
    ConfiguracionComponent,
    EmpresaComponent,
    LogoComponent
  ],
  exports: [
    NavPanelConfiguracionComponent,
    ConfiguracionComponent,
    EmpresaComponent,
    LogoComponent
  ]
})
export class ConfiguracionModule { }
